import {WindowRef} from './window-ref';

export class BrowserWindowRef implements WindowRef {
  getWindow(): any {
    return window;
  }

}
